
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"26","height":"34","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill":"#FFF","fill-rule":"nonzero"}},[_c('path',{attrs:{"d":"M9.398 0H2.602a2.608 2.608 0 00-.358 5.189v25.048A3.763 3.763 0 006 34a3.763 3.763 0 003.756-3.763V5.19A2.607 2.607 0 009.398 0zm-1.63 30.237c0 .977-.793 1.771-1.768 1.771a1.771 1.771 0 01-1.767-1.77V13.105a3.539 3.539 0 002.427-.212c.206-.096.434-.147.661-.147h.447v17.49zm0-19.482H7.32c-.516 0-1.036.116-1.503.335a1.553 1.553 0 01-1.13.075l-.455-.144V5.214h3.535v5.54zm1.63-7.533H2.602a.615.615 0 010-1.23h6.796a.615.615 0 010 1.23zM23.398 0h-6.796a2.608 2.608 0 00-.358 5.189V30.237A3.763 3.763 0 0020 34a3.763 3.763 0 003.756-3.763V5.19A2.607 2.607 0 0023.398 0zm-1.63 30.237c0 .977-.793 1.771-1.768 1.771a1.771 1.771 0 01-1.767-1.77V13.105a3.54 3.54 0 002.428-.212c.205-.096.433-.147.66-.147h.447v17.49zm0-19.482h-.447c-.516 0-1.036.116-1.503.335a1.553 1.553 0 01-1.13.075l-.456-.144V5.214h3.536v5.54zm1.63-7.533h-6.796a.615.615 0 010-1.23h6.796a.615.615 0 010 1.23z"}})])])
          )
        }
      }
    